import { render } from "./Appraisal_Categories.vue?vue&type=template&id=7671629a"
import script from "./Appraisal_Categories.vue?vue&type=script&lang=js"
export * from "./Appraisal_Categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__